import { Switch, Route, Redirect } from 'react-router-dom';

import withBaseLayout from 'components/ui/withBaseLayout';

import BotsPage from 'pages/bots/BotsPage';
import BotPage from 'pages/bots/BotPage';
import BotReportPage from 'pages/bot-reports/BotReportPage';
import BotReportEditPage from 'pages/bot-reports/BotReportEditPage';

import ExplorePage from 'pages/marketplace/ExplorePage';
import BotInfoPage from 'pages/marketplace/BotInfoPage';

import WorkObjectsPage from 'pages/work-objects/WorkObjectsPage';
import ImporterPage from 'pages/importer/ImporterPage';
import ExporterPage from 'pages/importer/ExporterPage';
import AdminPage from 'pages/admin/AdminPage';
import ProfilePage from 'pages/me/ProfilePage';
import HelpPage from 'pages/help/HelpPage';
import ViewChamadoPage from 'pages/help/ViewChamadoPage';
import ReportsPage from 'pages/reports/ReportsPage';
import ReportPage from 'pages/reports/ReportPage';
import DbsPage from 'pages/dbs/DbsPage';
import DbPage from 'pages/dbs/DbPage';
import TemplatesPage from 'pages/templates/TemplatesPage';
import TemplatePage from 'pages/templates/TemplatePage';
import OCRTemplatesPage from 'pages/ocr/OCRTemplatesPage';
import OCRTemplatePage from 'pages/ocr/OCRTemplatePage';

function App() {
  return (
    <Switch>
      <Route exact path="/" children={<Redirect to="/bots" />} />
      <Route exact path="/bots" children={<BotsPage />} />
      <Route path="/bots/:botId" children={<BotPage />} />

      <Route exact path="/marketplace" children={<ExplorePage />} />
      <Route path="/marketplace/:botId" children={<BotInfoPage />} />

      <Route exact path="/botreports/:reportId" children={<BotReportPage />} />
      <Route exact path="/botreports/:reportId/edit" children={<BotReportEditPage />} />

      <Route exact path="/databases" children={<DbsPage />} />
      <Route path="/databases/:dbId" children={<DbPage />} />

      <Route exact path="/importer/databases/:db_id" children={<ImporterPage />} />
      <Route exact path="/exporter/:type" children={<ExporterPage />} />
      <Route path="/admin/:tab?" children={<AdminPage />} />

      <Route exact path="/items/:job_id/:status/:date?" children={<WorkObjectsPage />} />

      <Route path="/help" children={<HelpPage />} />
      <Route exact path="/chamados/:id" children={<ViewChamadoPage />} />

      <Route exact path="/profile" children={<ProfilePage />} />
      <Route exact path="/reports" children={<ReportsPage />} />
      <Route exact path="/reports/:reportId" children={<ReportPage />} />

      <Route exact path="/templates" children={<TemplatesPage />} />
      <Route exact path="/templates/:templateId" children={<TemplatePage />} />

      <Route exact path="/ocr" children={<OCRTemplatesPage />} />
      <Route exact path="/ocr/add" children={<OCRTemplatesPage />} />
      <Route exact path="/ocr/:templateId/edit" children={<OCRTemplatePage />} />
    </Switch>
  );
}

export default withBaseLayout(App);
